import { normalizeAssetUrl } from './urls';

/**
 * Convert a `/media/...` asset path into a `/api/thumb` proxy URL.
 *
 * For non-`/media/` paths (external URLs, empty strings, etc.) the value
 * is returned unchanged so the caller can use it directly as an `<img src>`.
 */
// Snap requested pixel sizes to a fixed bucket so the server-side thumb cache
// is shared across devices. Without snapping, every (viewport × DPR) combo
// produces a unique cache key and triggers a cold ffmpeg run on first paint.
const THUMB_BUCKET_PX = 32;

function snap(n: number): number {
  return Math.max(THUMB_BUCKET_PX, Math.round(n / THUMB_BUCKET_PX) * THUMB_BUCKET_PX);
}

export function toThumbUrl(
  url: string | null | undefined,
  opts: { cssWidth: number; cssHeight: number; fit?: 'cover' | 'contain' },
): string {
  const normalized = normalizeAssetUrl(url);
  if (!normalized || !normalized.startsWith('/media/')) return normalized;

  const dpr = Math.min(2, Math.max(1, (window.devicePixelRatio || 1)));
  const w = Math.max(16, Math.min(2048, snap(opts.cssWidth * dpr)));
  const h = Math.max(16, Math.min(2048, snap(opts.cssHeight * dpr)));
  const fit = opts.fit || 'cover';
  return `/api/thumb?src=${encodeURIComponent(normalized)}&w=${w}&h=${h}&fit=${fit}`;
}
